import { styled } from '@sparky/stitches';

export const tooltipArrowSize = 6;

export const TooltipArrow = styled('div', {
  border: `${tooltipArrowSize}px solid transparent`,
  position: 'absolute',
  borderTop: `${tooltipArrowSize}px solid $backgroundDark`,
});

export const Spacer = styled('div', {
  width: '$targetMinWidth',
  height: '$targetMinHeight',
});
